module.exports = __webpack_public_path__ + "img/dual-heating-sm.a735e41f.svg";